import { Box } from "@mui/material";
import { Select } from "components";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SORT_ALPHABETICAL_ASCENDING, SORT_ALPHABETICAL_DESCENDING } from "utils/constants";
import { SortType } from "utils/types";
import { useStyles } from "./sort-dropdown-styles";

type SortProp = {
  selectSort: (sortid: SortType) => void;
  sort?: SortType;
};

export const SortDropdown: React.FC<SortProp> = ({ selectSort, sort }): React.ReactElement => {
  const { t } = useTranslation();
  const classes = useStyles();
  const sortBy = "sort-by";
  const sortBySelect = "sort-by-select";

  return (
    <Box className={classes.root}>
      <Box>
        <label id="sort-by">{t("sort_by")}</label>
      </Box>
      <Box className={classes.sortBox}>
        <Select
          title={t("sort_by")}
          buttonLabelId={sortBy}
          aria-labelledby={`${sortBy} ${sortBySelect}`}
          id={sortBySelect}
          options={[
            { title: t("sort_by_A_To_Z"), id: SORT_ALPHABETICAL_ASCENDING },
            { title: t("sort_by_Z_To_A"), id: SORT_ALPHABETICAL_DESCENDING },
          ]}
          value={sort}
          onChange={selectSort}
          MenuProps={{
            MenuListProps: {
              "aria-labelledby": sortBy,
            },
          }}
          endIcon={<KeyboardArrowDownIcon />}
          customClass={classes.sortClass}
        />
      </Box>
    </Box>
  );
};
